import { render } from "./EdoDocumentFlowSegment.vue?vue&type=template&id=53631d58&scoped=true"
import script from "./EdoDocumentFlowSegment.vue?vue&type=script&lang=js"
export * from "./EdoDocumentFlowSegment.vue?vue&type=script&lang=js"

import "./EdoDocumentFlowSegment.vue?vue&type=style&index=0&id=53631d58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53631d58"]])

export default __exports__